import Tab from './src/tab.vue'
import TabItem from './src/tab-item.vue'
import { SFCWithInstall, withInstall } from '@touchvue/utils'

export const ToTab: SFCWithInstall<typeof Tab> = withInstall(Tab, { TabItem })

export const ToTabItem: SFCWithInstall<typeof TabItem> = withInstall(TabItem)

export * from './src/instance'

export type { TabInstance, TabItemInstance } from './src/instance'
